import dayjs from 'dayjs'

const DATE_INPUT_FORMAT = 'DD.MM.YYYY'

export const parseDateRange = value => {
    if (!value) return { start: null, end: null }

    const [startStr, endStr] = value.split('—').map(s => s.trim())
    const start = dayjs(startStr, DATE_INPUT_FORMAT)
    const end = endStr ? dayjs(endStr, DATE_INPUT_FORMAT) : start

    return {
        start: start?.isValid() ? start : null,
        end: end?.isValid() ? end : null,
    }
}
